import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/shared/components'
import { PushNotificationsPage } from '@/pages/push/PushNotificationsPage'

export const Route = createFileRoute('/push')({
  component: () => (
    <RequirePermission section="push" action="view">
      <PushNotificationsPage />
    </RequirePermission>
  ),
})
